// AIDEV-NOTE: Centralized environment config for bulk-actions (Sentry/PostHog)

export const ENVS = {
  appKey: process.env.API_KEY!,
  environment: process.env.ENVIRONMENT!,

  // Sentry configuration
  // AIDEV-NOTE: Keep Sentry canonical; use enableSentryInDev to control non-prod delivery
  sentryDsn:
    process.env.SENTRY_DSN ||
    "https://7e7b9125311e43d8b8fb43526762a595@o923831.ingest.sentry.io/6368931",
  sentryTracesSampleRate: Number(process.env.SENTRY_TRACES_SAMPLE_RATE ?? 0),
  enableSentryInDev: process.env.ENABLE_SENTRY_IN_DEV === "true",

  sentryTraceTargets: getSentryTraceTargets(),
  gitCommit: process.env.COMMIT_REF?.slice(0, 7) ?? "unknown",
};

// AIDEV-NOTE: Derive trace propagation targets from known hosts (tighten later if needed)
// Prefer env/configured URLs over broad regexes to avoid leaking headers.
function getSentryTraceTargets(): (RegExp | string)[] {
  const targets: (RegExp | string)[] = [];
  const paywallUrl = process.env.PAYWALL_URL;
  if (paywallUrl) {
    try {
      const u = new URL(paywallUrl);
      // match the paywall host (e.g., *.netlify.app domain)
      targets.push(new RegExp(u.hostname.replace(/\./g, "\\."), "i"));
    } catch {
      // ignore malformed URL
    }
  }
  return targets;
}
